
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Uri in der dritten Welle`}</h2>
    <p>{`Im Innerschweizer Kanton ist die Lage prekär. Am Montag, 12. April 2021, heisst es an einer `}<a parentName="p" {...{
        "href": "https://www.nau.ch/news/schweiz/coronavirus-kanton-uri-verscharft-massnahmen-65905177"
      }}>{`Medienkonferenz`}</a>{` der Regierung, die Infektionszahlen seien «besorgniserregend hoch». Tatsächlich sind nahezu alle Urner Gemeinden derzeit überdurchschnittlich betroffen. Der Kanton reagiert: In den Schulen gibt es mehr Tests, im Kantonsspital sind erste planbare Operationen verschoben worden, und das Skigebiet Andermatt macht auf Geheiss der Regierung vorzeitig dicht.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;